/*
Descrição..........: Importação de módulos externos e declaração de módulos locais
Autor..............: Pablo Ebbers
Data Criação.......: 01/03/2020
Última Atualização.: 17/03/2020
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProdutoListPageRoutingModule } from './produto-list-routing.module';

import { ProdutoListPage } from './produto-list.page';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ProdutoListPageRoutingModule
  ],
  declarations: [ProdutoListPage]
})
export class ProdutoListPageModule {}
